import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetServerSidePropsContext } from "next";
import { NextPage } from "next";
import MainPage from "components/pages/Main";
import { NowTrendingData } from "interfaces/main";
import useRestoreScroll from "utils/useRestoreScroll";
import { getServerSession } from "next-auth";
import { authOptions } from "./api/auth/[...nextauth]";

interface Props {
  isMobile: boolean;
  trendingData: NowTrendingData[];
  countryRiskData: NowTrendingData[];
  isHoliday?: boolean;
  themeListData?: any;
  isLoginUser: boolean;
  portId: number | null;
  initialHighScoreList?: any[] | null;
  initialHotTopicList?: any[] | null;
  initialMainIndex?: { index?: any[] } | null;
}

const Main: NextPage<Props> = ({
  isMobile,
  isLoginUser,
  portId,
  initialHighScoreList,
  initialHotTopicList,
  initialMainIndex,
}) => {
  useRestoreScroll("main");

  return (
    <MainPage
      isMobile={isMobile}
      isLoginUser={isLoginUser}
      portId={portId}
      initialHighScoreList={initialHighScoreList}
      initialHotTopicList={initialHotTopicList}
      initialMainIndex={initialMainIndex}
    />
  );
};
export default Main;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  let locale = context.locale || context.defaultLocale || "ko";

  const { query } = context;
  const session: any = await getServerSession(
    context.req,
    context.res,
    authOptions
  );

  let portId = null;
  if (query.type === "portfolio") {
    const pfUser = await fetch(
      `${process.env.NEXTAUTH_URL}/api/auth/portfolio?email=${session?.user?.email}`
    );
    const status = pfUser.status;
    const isError = status === 500;
    const isHavePort = status === 200;
    if (isHavePort) {
      const pfUserData = await pfUser?.json();
      portId = pfUserData?.PORT_ID;
    }
    if (!session || (!isError && !isHavePort)) {
      return {
        redirect: {
          destination: "/portfolio/new",
          permanent: false,
        },
      };
    }
  }

  const base = process.env.NEXTAUTH_URL;
  // explore 탭(기본)만 GEO 본문용 리스트를 프리패치 — 다른 탭은 로그인/개인화 위주
  const isExplore =
    !query.type || query.type === "" || query.type === "explore";

  let initialHighScoreList: any[] | null = null;
  let initialHotTopicList: any[] | null = null;
  let initialMainIndex: { index?: any[] } | null = null;

  if (isExplore && base) {
    const [highScore, hotTopic, mainIndex] = await Promise.all([
      fetch(`${base}/api/hightotalscore?limit=5&loc=`)
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null),
      fetch(`${base}/api/hotTopic?limit=3`)
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null),
      fetch(`${base}/api/mainIndex`)
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null),
    ]);
    initialHighScoreList = highScore;
    initialHotTopicList = hotTopic;
    initialMainIndex = mainIndex;
  }

  return {
    props: {
      hasMetaData: false, // 기본 메타데이터를 렌더링하도록 설정
      isLoginUser: session,
      portId,
      initialHighScoreList,
      initialHotTopicList,
      initialMainIndex,
      ...(await serverSideTranslations(locale as string, [
        "main",
        "watchlist",
      ])),
    },
  };
}
